import React from "react";

import { FlexContainer, Heading } from "../../constants/assets/containers";
import Permission from "../../components/Common/Permission";
import FilterButton from "../../components/Common/FilterButton";
import Button from "sushiweb/Button";
import styled from "styled-components";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { useHistory } from "react-router-dom";
import PendingDeductionModal from "../../components/PendingDeduction/PendingDeductionModal";
import * as PendingDeductionAction from "../../store/actions/PendingDeduction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PendingDeductionList from "../../components/PendingDeduction/PendingDeductionList";
import ListPagination from "../../components/Common/ListPagination";

const PendingDeduction = (props) => {
  const allActions = MenuActionsMappings[MenuNames.PENDING_DEDUCTION];
  const history = useHistory();
  const [modalState, setModalState] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const {
    getPendingDeductionList,
    pendingDeductions,
    nextPage,
    prevPage,
    activeFilters,
  } = props;

  React.useEffect(() => {
    if (Object.keys(activeFilters).length) {
      getPendingDeductionList(currentPage, activeFilters);
    }
  }, []);

  const handleClick = (type, id) => {
    if (type === "Bulk") {
      history.push("/pending-deduction-bulk-upload");
    } else {
      setModalState(type);
    }
  };
  const handleClose = () => {
    setModalState(false);
  };
  const handleNavClick = (action) => {
    if (action === "prev") {
      getPendingDeductionList(currentPage - 1, activeFilters);
      setCurrentPage(currentPage - 1);
    } else {
      getPendingDeductionList(currentPage + 1, activeFilters);
      setCurrentPage(currentPage + 1);
    }
  };
  return (
    <PendingDeductionViewContainer>
      <FlexContainer align="flex-start">
        <Heading>Pending Deduction</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={activeFilters}
              data-testid="callDepartmentsFilterButton"
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.BULK_UPLOAD]}>
            <Button
              onClick={() => handleClick("Bulk", null)}
              className="sushi-btn ml-12"
              data-testid="callDepartmentsCreationButton"
            >
              Bulk Upload
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <PendingDeductionList pendingDeductions={pendingDeductions} />
      {/*<ListPagination*/}
      {/*  nextPage={nextPage}*/}
      {/*  prevPage={prevPage}*/}
      {/*  handleNavClick={handleNavClick}*/}
      {/*/>*/}
      {modalState && (
        <PendingDeductionModal
          modalState={modalState}
          handleClose={handleClose}
        />
      )}
    </PendingDeductionViewContainer>
  );
};

function mapStateToProps(state) {
  const { PendingDeduction } = state;
  return {
    pendingDeductions: PendingDeduction.pendingDeductions,
    prevPage: PendingDeduction.prevPage,
    nextPage: PendingDeduction.nextPage,
    activeFilters: PendingDeduction.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getPendingDeductionList: bindActionCreators(
      PendingDeductionAction.getPendingDeductionList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingDeduction);

const PendingDeductionViewContainer = styled.section``;
